export const PRODUCTS_QUERY_KEY = 'products'
export const PRODUCTS_FOR_SALE_QUERY_KEY = 'productsForSale'
export const PRODUCTS_FOR_CONSUMABLES_QUERY_KEY = 'productsForConsumables'
export const ARCHIVED_PRODUCTS_QUERY_KEY = 'archivedProducts'
export const PRODUCTS_LEFTOVERS_QUERY_KEYS = 'productsLeftovers'
